export default __webpack_public_path__ + "static/artistBox-terra404-6ff7f4d372d80c3321f1ca305a826f98.png";